import * as React from "react";
const SvgArrwoDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 7, viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5 5L9 0.999999", stroke: "#FFE540", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgArrwoDown;
